import React from 'react';
import { Table } from 'semantic-ui-react';
import { TaxMapReportOrder } from '../types';
import SearchViewTableBody from './SearchViewTableBody';

interface PropTypes {
  reportData: TaxMapReportOrder[];
}

const TableWrapper = (props: PropTypes) => (
  <Table fixed sortable celled compact striped singleLine size="small" className="tableTwelve">
    <SearchViewTableBody reportData={props.reportData} />
  </Table>
);

export default TableWrapper;
